import React,{useEffect,useState} from 'react';
import {Link} from 'react-router-dom';
import {Justify} from 'react-bootstrap-icons';
import MetaMaskOnboarding from '@metamask/onboarding';
import {Path} from '../Path.js';

/* metamask code */
const CONNECT_TEXT = 'Connect to MetaMask';
const CONNECTED_TEXT = 'Connected to MetaMask';
const NOT_CONNECTED = 'Not connected';
/* //metamask code */

function Header(){
  const [showNavBox, setShowNavBox] = useState(false);
  const [accounts, setAccounts] = useState([]);
  // const [buttonText, setButtonText] = useState();
  const [account, setAccount] = useState();
  const [isDisabled, setDisabled] = useState(false);
  const onboarding = React.useRef();
  const showSidebar=()=>{
    setShowNavBox(true);
  } 
  const hideSidebar=()=>{
    setShowNavBox(false);
  }
  function handleNewAccounts(newAccounts) {
    setAccounts(newAccounts);
  }
  const connectMetamask = () => {
    if (MetaMaskOnboarding.isMetaMaskInstalled()) {
      console.log('clicked');
      window.ethereum
      .request({ method: 'eth_requestAccounts' })
      .then((newAccounts) => setAccounts(newAccounts));
    } else {
      onboarding.current.startOnboarding();
    }
  };
  //metamask
  useEffect(() => {
    if (!onboarding.current) {
      onboarding.current = new MetaMaskOnboarding();
    }
    if (MetaMaskOnboarding.isMetaMaskInstalled()) {
      if (accounts.length > 0) {
        // setButtonText(CONNECTED_TEXT);
        setDisabled(true);
        onboarding.current.stopOnboarding();
        var ethDefaultAccount = accounts[0];
        setAccount(ethDefaultAccount);   
      } else {
        // setButtonText(CONNECT_TEXT);
        setAccount(NOT_CONNECTED);
        setDisabled(false);
      }
    }
    if(window.ethereum!==undefined)
        window.ethereum.on('accountsChanged', handleNewAccounts);
  }, [accounts]);
  // metamask
  return(
    <>
      <div id="header" className="container-fluid" style={{position:"relative"}}>
          <div className="row header">
          {!showNavBox &&
          (<div className="col-xl-6 col-lg-6 col-md-4 col-sm-6 col-xs-9 head top_logo">
          <Link to="/"><img src={'images/logo.png'} alt="logoo" className='header-logo'/></Link>
          </div>)}

          <div className="col-xl-3 col-lg-3 col-md-4 col-sm-2 social large_screen_navbar">
        
          <ul className='social-head'>
              <li className='social-list' onClick={()=>window.open('https://twitter.com/LittleBillions')}><Link to='/'><img src={'images/twit-head.png'} alt="twit-head" className='head-social effecthov' /></Link></li>
              <li className='social-list' onClick={()=>window.open('https://www.instagram.com/littlebillionaires.io/')}><Link to='/'><img src={'images/insta-head.png'} alt="insta-head" className='head-social effecthov' /></Link></li>
              <li className='social-list' onClick={()=>window.open('https://discord.gg/7UD5mSxSSW')}><Link to='/'><img src={'images/dis-head.png'} alt="dis-head" className='head-social effecthov' /></Link></li>
          </ul>
        </div>
          
        {!showNavBox &&
          (<div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-xs-3 head">
            {isDisabled===false ?
              (<button className="custom-btn btn-banner header header_top_btn large_screen_navbar" onClick={connectMetamask}>CONNECT WALLET</button>) :
              (<button className="custom-btn btn-banner header header_top_btn large_screen_navbar">WALLET CONNECTED</button>)
            }
            <span className="small_screen_navbar bar_icon" onClick={showSidebar}><Justify size="28" style={{marginBottom:"4px"}}/></span>
          </div>)}
          {showNavBox &&
          (<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 top_nav_box">
            <div className="row header" style={{paddingBottom:"10px"}}>
              <div className="col-xl-6 col-lg-6 col-md-4 col-sm-6 col-xs-9 head top_logo">
                <Link to="/"><img src={'images/new/white_logo.png'} alt="header-logo" className='header-logo' style={{height:"32px",marginTop:"9px"}}/></Link>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-xs-3 head">
                <span className="small_screen_navbar small_bar_icon" onClick={hideSidebar} style={{marginTop:"6px"}}><Justify size="28" style={{marginBottom:"4px"}}/></span>
              </div>
            </div>
            <ul>
              {isDisabled===false ?
                (<li onClick={connectMetamask}>Connect Wallet</li>) :
                (<li onClick={connectMetamask}>Wallet connected</li>)
              }
              
              <li><Link  className="whitepaper" to="/little-token">Little Token</Link></li>
              <li><a href={Path+"Whitepaper_FINAL_1.1-2.pdf"} target="_blank" className="whitepaper" rel="noreferrer">Whitepaper</a></li>
              <li onClick={()=>window.open('https://discord.gg/7UD5mSxSSW')}>Discord</li>
              <li onClick={()=>window.open('https://twitter.com/LittleBillions')}>Twitter</li>
              <li onClick={()=>window.open('https://www.instagram.com/littlebillionaires.io/')}>Instagram</li>
            </ul>
          </div>)}
        </div>
      </div>
    </>
  );
}   

export default Header;